import { fetchAuthSession } from 'aws-amplify/auth';
import { checkAuthAndRedirect } from './authUtils';
import { textExtractionService } from './textExtractionService';

export const uploadService = {
  // Upload a file with domain information
  uploadFile: async (file: File, tenantcode: string, userEmail?: string) => {
    try {
      console.log('uploadFile called with:', { fileName: file.name, tenantcode, userEmail });
      
      const isAuthenticated = await checkAuthAndRedirect();
      if (!isAuthenticated) throw new Error('Authentication required');
      console.log('Authentication check passed');
      
      // Extract text from PDF or Word files
      let fileToUpload = file;
      let fileName = file.name.substring(0, file.name.lastIndexOf('.')) || file.name;
      
      if (file.type === 'application/pdf' || 
          file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
          file.type === 'application/msword') {
        console.log('Extracting text from document...');
        const { text, newFileName } = await textExtractionService.extractText(file);
        fileToUpload = textExtractionService.createTextFile(text, newFileName);
        fileName = newFileName.substring(0, newFileName.lastIndexOf('.')) || newFileName;
        console.log('Text extraction completed, new fileName:', fileName);
      }
      
      // Get the current authenticated user's JWT token
      const session = await fetchAuthSession();
      const token = session.tokens?.idToken?.toString();
      console.log('Got JWT token:', token ? 'Yes' : 'No');
      
      // Create form data for the file upload
      const formData = new FormData();
      formData.append(fileName, fileToUpload);
      formData.append('tenantcode', tenantcode);
      if (userEmail) {
        formData.append('email', userEmail);
      }
      console.log('FormData created with fileName:', fileName, 'tenantcode:', tenantcode);

      // Make API call to Lambda via API Gateway
      const headers: HeadersInit = {};
      
      if (token) {
        headers.Authorization = "Bearer " + token;
      }
      
      console.log('Making API call to:', process.env.REACT_APP_LAMBDA_API_ENDPOINT);
      const response = await fetch(process.env.REACT_APP_LAMBDA_API_ENDPOINT!, {
        method: 'POST',
        mode: 'cors',
        headers,
        body: formData,
      });

      console.log('API response status:', response.status, response.statusText);

      if (!response.ok) {
        let errorMessage = 'Failed to upload file';
        try {
          const errorData = await response.json();
          console.log('Error response JSON:', errorData);
          errorMessage = errorData.message || errorMessage;
        } catch {
          const errorText = await response.text();
          console.log('Error response text:', errorText);
          errorMessage = errorText || errorMessage;
        }
        throw new Error(errorMessage);
      }

      try {
        const jsonResponse = await response.json();
        console.log('Success response JSON:', jsonResponse);
        return jsonResponse;
      } catch {
        const textResponse = await response.text();
        console.log('Success response text:', textResponse);
        return textResponse;
      }
    } catch (error) {
      console.error('uploadFile error:', error);
      throw error;
    }
  }
};